module.exports = __webpack_public_path__ + "media/Video 12.74ccd935.mp4";